export default {
    downloadApplicationPaper({}) {
        return this.$downloader.download(this.$axios, this.$api.tenantAdmin.downloadApplicationPaper)
        .catch(error => {
        });
    }
}